import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from '@/locales/en/common.json';
import patientApp from '@/locales/en/patientApp.json';
import dashboard from '@/locales/en/dashboard.json';

export const defaultNS = 'common';
export const resources = {
  en: {
    common: enCommon,
    patientApp: patientApp,
    dashboard: dashboard,
  },
};

export const ns = [
  'common',
  'patientApp',
  'dashboard',
];

i18next
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    ns,
    defaultNS,
    resources,
  })
  .catch((error: unknown) => {
    console.error('i18next initialization failed', error);
  });

export default i18next;
